
import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Button } from "antd";
import './style.css'

interface StepThreeProps {
  editorContent: string;
  handleEditorChange: (content: string) => void;
  handleFormSubmit: (e: any) => void;
  isLoading:boolean;
  handleImageUpload: (blobInfo: any, success: (url: string) => void, failure: (error: string) => void) => void;

}

const StepThree: React.FC<StepThreeProps> = ({
  editorContent,
  handleEditorChange,
  handleFormSubmit,
  isLoading,
  handleImageUpload
  
}) => {


  return (
    <div>
      <h2>TinyMCE Editor</h2>
      <Editor
          apiKey="xxg0gzzc31y3rom1n3l09yp8gsokn9i5gkgy0g9ux7bg59yc"
          value={editorContent}
          onEditorChange={handleEditorChange}
          init={{
            height: 500,
            menubar: true,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "media", 
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "wordcount",
              "table",
              "code",
              "emoticons",
            ],
            toolbar: `
              undo redo | formatselect | bold italic underline strikethrough | 
              alignleft aligncenter alignright | code | link image media | 
              numlist bullist outdent indent | table | charmap emoticons`,
            file_picker_callback: (callback: any, value: any) => {
              const input = document.createElement("input");
              input.type = "file";
              input.accept = "image/*,video/*"; 
              
              input.onchange = async function () {
                const file = input.files ? input.files[0] : null;
                if (file) {
                  handleImageUpload({ blob: () => file }, callback, (error) => {
                    console.error(error); 
                  });
                }
              };
              input.click();
            },
            image_title: true,
            automatic_uploads: true,
            images_upload_url: "/upload",
          }}

        />
      <Button htmlType="submit" className="bg-teal-800 w-[200px] mt-[7px]
        text-white font-semibold py-2 px-4 border
           border-gray-400 rounded shadow" loading={isLoading}  onClick={handleFormSubmit} >
           Save Blog
          </Button>
    </div>
  );
};

export default StepThree;
